import { Radio as BaseRadio } from '@base-ui/react/radio'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface RadioGroupIndicatorProps extends PartProps<BaseRadio.Indicator.Props> {
  className?: string
}

function RadioGroupIndicator({ className, ...props }: RadioGroupIndicatorProps) {
  return (
    <BaseRadio.Indicator
      keepMounted
      className={twMerge(
        'size-1.5 rounded-full bg-[color:var(--text-on-info)] transition-[scale,opacity] duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
        'data-[unchecked]:scale-0 data-[unchecked]:opacity-0',
        'group-data-[disabled]:bg-foreground-disabled',
        className,
      )}
      {...props}
    />
  )
}

export { RadioGroupIndicator }
